module.exports = __webpack_public_path__ + "static/media/proud.159ae1c5.svg";